// Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.

// Type of map, used for rendering logic
export enum MapType {
  MultiMachine = 'MultiMachine',
  PrecisionAg = 'PrecisionAg'
}
